import { ShortcutsSheet as Sheet } from '@flow/ui/components';

import { t } from '../i18n/es.js';

import { GOTO_KEYS } from './commands.js';

/**
 * Shortcuts available in the shell today (docs/05 §6.1). The navigation rows come from the same
 * table the listener uses; triage and list shortcuts join this list in their changes.
 */
export function shortcutRows(): { keys: string; description: string }[] {
  return [
    { keys: '⌘K', description: t.shell.shortcuts.palette },
    { keys: 'N', description: t.shell.shortcuts.capture },
    ...Object.entries(GOTO_KEYS).map(([letter, view]) => ({
      keys: `G ${letter.toUpperCase()}`,
      description: t.shell.shortcuts.goTo(t.shell.viewNames[view] ?? view),
    })),
    { keys: '?', description: t.shell.shortcuts.help },
    { keys: 'Esc', description: t.shell.shortcuts.close },
  ];
}

export function ShortcutsSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      rows={shortcutRows()}
      labels={{ title: t.shell.shortcuts.title, close: t.shell.shortcuts.closeButton }}
    />
  );
}
